const state = {
    darkMode: false,
};

const mutations = {
    updateDarkMode(state, darkMode) {
        state.darkMode = darkMode
    },
    updateDrawerFooterInset(state, inset) {
        state.footer.inset = inset
    }
};

export default {
    state,
    mutations
};
